export const finanzUebersicht = {
    // Einnahmen/Ausgaben pro Jahr (fuer KPI + Chart)
    MixDiagrammEinnahmenClass: {
        url: "Diagramm/einnahmenbar",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_MixDiagrammEinnahmen_finanzUebersichtReducer'
    },

    // Finanzierungsfortschritt-Text ("noch noetige Einnahmen: X €")
    JahresFinanzierungsfortschrittClass: {
        url: "Finanzierung/nochNoetigesGeldFuerDasJahr",
        receiveType: 'RECEIVE_JahresFinanzierungsfortschritt_finanzUebersichtReducer'
    },

    // EVU Rechnungsdaten als HTML (Detail-Akkordeon)
    EvuBillClass: {
        url: "Finanzierung/evu",
        defaultSegment: "Finanzierung",
        forceRefresh: false,
        receiveType: 'RECEIVE_EvuBill_finanzUebersichtReducer'
    },

    // PV Einspeise-Rechnungen als HTML (Detail-Akkordeon)
    PvBillClass: {
        url: "Finanzierung/pv",
        defaultSegment: "Finanzierung",
        forceRefresh: false,
        receiveType: 'RECEIVE_PvBill_finanzUebersichtReducer'
    },

    // PV Jahresendabrechnung als HTML (Detail-Akkordeon)
    PvFinalBillClass: {
        url: "Finanzierung/pvfinal",
        defaultSegment: "Finanzierung",
        forceRefresh: false,
        receiveType: 'RECEIVE_PvFinalBill_finanzUebersichtReducer'
    }
};
